import { PlusOutlined } from '@ant-design/icons';
import { Button, Table, Typography } from 'antd';
import SearchInput from '../../components/ui/SearchInput';
import { getRoutes } from '../../routes/Routes';

const Leads = () => {

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Whatsapp',
            dataIndex: 'whatsapp',
            key: 'whatsapp',
        },
        {
            title: 'Terms',
            dataIndex: 'terms',
            key: 'terms',
        },
        {
            title: 'Business Hours',
            dataIndex: 'business_hours',
            key: 'business_hours',
        },
        {
            title: 'Business Type',
            dataIndex: 'business_type',
            key: 'business_type',
        }
    ]

    return (
        <div className="invoice-page">
            <div className="page-header mb-3">
                <div className="flex justify-content-between align-items-center mb-2">
                    <Typography.Title level={3} className="page-title">
                        Leads
                    </Typography.Title>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        href={getRoutes().add_lead.route()}
                    >
                        Add leads
                    </Button>
                </div>

                <div className="flex align-items-center gap-2 flex-wrap">
                    <SearchInput maxWidth="25rem" />
                </div>
            </div>

            <Table
                size="small"
                columns={columns}
                rowKey={(record) => record?.id}
                dataSource={[]}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />


        </div>
    )
}

export default Leads